module.exports = __webpack_public_path__ + "img/DSC_6016-(edit).de6a7f96.jpg";